import {createRouter, createWebHistory, type RouteRecordRaw} from 'vue-router'
import ImplicitCallback from '@/views/ImplicitCallback.vue'
import qs from 'qs'

const publicPath = (import.meta.env.VITE_PUBLIC_PATH || '').replace(/\/$/, '')
const callbackAlias = `${publicPath}/implicit/callback`.replace(/\/+/g, '/')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/mymachine/'
  },
  {
    name: 'ImplicitCallback',
    path: '/implicit/callback',
    component: ImplicitCallback,
    alias: callbackAlias !== '/implicit/callback' ? [callbackAlias] : []
  }
  // Wildcard is removed - will be handled by app routes through plugin
]

const routerBase = (import.meta.env.VITE_PUBLIC_PATH || import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/'

const router = createRouter({
  history: createWebHistory(routerBase),
  parseQuery: (query: string) => qs.parse(query) as Record<string, any>,
  routes
})

export default router
